import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[onlyNumbers]' })
export class OnlyNumber {

  @Input() mxlength: number;
  private readonly regEx = new RegExp('^[0-9]*$');

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (
      (['Enter', 'Tab', 'Esc', 'Home', 'End', 'Backspace', 'Insert', 'Delete',
        'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown'].includes(event.key)) ||
      (['a', 'c', 'v', 'x', 'z'].includes(event.key.toLowerCase()) && event.ctrlKey === true)) {
      return;
    }
    if (!this.isValid(event.key)) { event.preventDefault(); }
  }

  @HostListener('paste', ['$event']) onPaste(e) {
    let pastedText = e.clipboardData.getData('text/plain');
    if (pastedText) {
      if (!this.isValid(pastedText)) { event.preventDefault(); }
    }
  }

  private isValid(elegible: string): boolean {
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(elegible);
    return this.regEx.test(elegible) && !this.isOverSize(next);
  }

  private isOverSize(str: string): boolean {
    if (this.mxlength && str) {
      return str.length > this.mxlength;
    }
    return false;
  }

}

@Directive({ selector: '[numbersOnly]' })
export class NumbersOnlyDirective {

  constructor(private el: ElementRef, private formCtrl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event) {
    const regEx = /[^0-9]*/g;
    this.formCtrl.control.setValue(this.el.nativeElement.value.replace(regEx, ''));
    return;
  }

}

@Directive({ selector: '[decimalOnly]' })
export class DecimalOnlyDirective {

  private regex: RegExp = new RegExp(/^\d*\.?\d{0,4}$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) { return; }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) { event.preventDefault(); }
  }

}

@Directive({ selector: '[minMax]' })
export class MinMaxDirective {

  @Input() public minValue: number;
  @Input() public maxValue: number;

  constructor(private ref: ElementRef) { }

  @HostListener('input', ['$event'])
  public onInput(a_Event: InputEvent): void {

    let val = parseInt(this.ref.nativeElement.value);
    if (this.maxValue !== null && this.maxValue !== undefined && val >= this.maxValue) {
      this.ref.nativeElement.value = this.maxValue.toString();
    }
    else if (this.minValue !== null && this.minValue !== undefined && val <= this.minValue) {
      this.ref.nativeElement.value = this.minValue.toString();
    }
  }

}
